import React from "react";
import Popup from "reactjs-popup";
import styles from "./Modal.module.css";

interface ModalProps {
  open: boolean;
  onClose?: () => any;
}
const Modal = ({
  children,
  open,
  onClose,
}: React.PropsWithChildren<ModalProps>) => {
  return (
    <Popup open={open} closeOnDocumentClick onClose={() => onClose?.()}>
      {" "}
      <div className={styles.modal}>
        <div className="modal-body">{children}</div>
      </div>
    </Popup>
  );
};

export default Modal;
